/**
 * Result is class that wraps a value and/or an error and provides some helpful methods to
 * interact with a Result
 **/
export class Result {
  /**@type {any}**/
  #value;

  /**@type {Error}**/
  #error;

  /**
   * @param v {any} Value
   * @param e {Error} Error
   **/
  constructor(v, e) {
    this.#value = v;
    this.#error = e;
  }

  /**
   * @param {Error} e Error
   * @return {Result}
   **/
  static new_error(e) {
    return new Result(null, e);
  }

  /**
   * @param {any} v Value
   * @return {Result}
   **/
  static new_value(v) {
    return new Result(v, null);
  }

  /**
   * unwrap returns the value if there is no error other witse it throws
   * @returns value
   **/
  unwrap() {
    if (this.#error != null) throw this.#error;

    return this.#value;
  }

  /**
   * unwrap_or_null returns the value or null regardless of error.
   * @return {any} value
   **/
  unwrap_or_null() {
    return this.#value;
  }

  /**
   * is_error returns true if there is an error false if not
   * @return {boolean}
   **/
  is_error() {
    if (this.#error != null) return true;
    return false;
  }

  /**
   * error returns the error
   * @return {Error}
   **/
  error() {
    return this.#error;
  }
}

/**
 * reg_custom_components registers all custom `components`
 *
 * ## Notes
 * - Only works with components that have elname static string. If component does not have elname it will silently fail.
 * @param {Array<CustomElementConstructor>} components variadic list of components
 */
export function reg_custom_components(...components) {
  components.forEach((cmp) => {
    if (cmp.elname == null || cmp.elname === "" || cmp.elname === undefined) {
      return;
    }

    if (!customElements.get(cmp.elname)) {
      customElements.define(cmp.elname, cmp);
    }
  });
}
